import SpinningLoader from '../components/SpinningLoader/SpinningLoader';

export const CallbackPage = () => {
  return <SpinningLoader />;
};
